import { call, put, takeLatest } from 'redux-saga/effects';
import actions, { Types } from '~/store/ducks/rates';
import api from '~/services/api';

function* loadRates({ partner, mcc }) {
  try {
    const params = {
      acquirer: 'stone',
      anticipate: 'false',
      mcc
    };

    const { data: defaultRatesPOS } = yield call(api.get, '/v1/default-rates', {
      params: {
        channel: 'pos',
        ...params
      }
    });

    const { data: defaultRatesOnline } = yield call(
      api.get,
      '/v1/default-rates',
      {
        params: {
          channel: 'online',
          ...params
        }
      }
    );

    const rates = yield call(
      api.get,
      `/v1/partners/${partner}/rates?count=99999999`
    );

    const defaultRates = [
      ...defaultRatesPOS.rates.map(r => ({ ...r, channel: 'pos' })),
      ...defaultRatesOnline.rates.map(r => ({ ...r, channel: 'online' }))
    ].map(r => ({
      card_issuer: r.card_issuer,
      channel: r.channel,
      installment: r.installment,
      acquirer: r.acquirer,
      anticipation: r.anticipation || 0,
      paggi: r.paggi
    }));

    const parsedRates = rates.data.rates.map(r => ({
      card_issuer: r.card_issuer,
      channel: r.channel,
      installment: r.installment,
      partner: r.rates.partner,
      acquirer: r.rates.acquirer,
      anticipation: r.rates.anticipation,
      paggi: r.rates.paggi
    }));

    const testSearch = (d, r) =>
      d.channel === r.channel &&
      d.card_issuer === r.card_issuer &&
      d.installment === r.installment;

    const joinedRates = defaultRates.map(d => {
      const index = parsedRates.findIndex(r => testSearch(d, r));
      const item = ~index ? parsedRates[index] : d;

      return {
        partner: item.partner || 0,
        card_issuer: item.card_issuer || d.card_issuer,
        channel: item.channel || d.channel,
        installment: item.installment || d.installment,
        acquirer: item.acquirer || d.acquirer,
        anticipation: item.anticipation || d.anticipation,
        paggi: item.paggi || d.paggi
      };
    });

    const res = joinedRates.map(i => ({
      ...i,
      partner: i.partner ? i.partner : i.acquirer + i.anticipation + i.paggi
    }));

    yield put(actions.loadRatesSuccess(res));
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

const sagas = [takeLatest(Types.LOAD_RATES, loadRates)];

export default sagas;
